import { Box, Button, Grid, Typography } from '@mui/material';
import img from '../../assets/images/error.jpg';

export default function Error() {
  return (
    <Box height="100vh" width="100vw" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Box component="img" src={img} alt="página não encontrada" width="90%" maxWidth={400} />
      <Typography
        sx={{
          fontSize: 60,
          fontWeight: 700,
          letterSpacing: -9,
          textShadow: theme => `2px 2px 1px ${theme.palette.additionalColors.darkMain}`,
          color: theme => theme.palette.primary.main,
        }}
      >
        OPS !!!
      </Typography>
      <Box textAlign="center" width="90%" margin="0 auto">
        <Typography>
          Aconteceu um erro! <br />
          Tente novamente ou acessa a página inicial
        </Typography>
      </Box>

      <Box width="90%" maxWidth={500}>
        <Grid container mt={3} mb={3} spacing={2}>
          <Grid item xs={12} sm={6}>
            <Button variant="contained" color="primary" onClick={() => window.location.reload()} fullWidth>
              Tentar Novamente
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.location = '/';
              }}
              fullWidth
            >
              Página Inicial
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
